module.exports = __webpack_public_path__ + "static/img/empty.c3f257a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/empty.png
// module id = Y+1u
// module chunks = 80